var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Highlighter from 'react-highlight-words';
import { Checkbox } from '@mui/material';
import GlobalSearchUtils from '../globalSearch/globalSearchUtils';
import AccurityIcon from '../icon/components/AccurityIcon';
export var checkedIcon = React.createElement(AccurityIcon, { iconName: "mui:CheckBox", fontSize: "small" });
export var uncheckedIcon = React.createElement(AccurityIcon, { iconName: "mui:CheckBoxOutlineBlank", fontSize: "small" });
export var indeterminateIcon = React.createElement(AccurityIcon, { iconName: "mui:IndeterminateCheckBox", fontSize: "small" });
var AutocompleteSelectorListItem = function (_a) {
    var label = _a.label, filterText = _a.filterText, checked = _a.checked, indeterminate = _a.indeterminate, isGroupHeader = _a.isGroupHeader, liProps = __rest(_a, ["label", "filterText", "checked", "indeterminate", "isGroupHeader"]);
    return React.createElement("li", __assign({}, liProps),
        React.createElement(Checkbox, { icon: uncheckedIcon, checkedIcon: checkedIcon, indeterminateIcon: indeterminateIcon, indeterminate: indeterminate, style: { marginRight: 8, marginLeft: isGroupHeader ? -14 : 0 }, checked: checked }),
        React.createElement(Highlighter, { searchWords: filterText.split(' '), textToHighlight: label, highlightTag: 'b', findChunks: GlobalSearchUtils.findChunksAtBeginningOfWords }));
};
export default AutocompleteSelectorListItem;
//# sourceMappingURL=AutocompleteSelectorListItem.js.map